import React, { Component } from 'react'
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { 
  Button,FormGroup,Checkbox,
  Intent, Spinner, RadioGroup, Icon
} from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import DateTimeInput from 'components/DateTimeInput';
import moment from 'moment';
import GeoComplete from '../../helpers/GeoComplete';
import { currencySymbol, currencyFormattedAmount } from 'helpers/currency';
import QuestionRadio from 'components/Booking/QuestionRadio';
import QuestionSelect from 'components/Booking/QuestionSelect';
import QuestionTextbox from 'components/Booking/QuestionTextbox';
import Lockr from 'lockr';
import { Api } from 'services/Api';
import { BookingPageSkeleton, hasGroupedQuestions,
  BookingPageHeader, BookingSection, BookingTicket, BookingAttachments,
  ServiceTypeSelectWrap, joinAddress, bookingBrandStyle
} from 'components/Booking/BookingLayout';
import BookingStepper from 'components/BookingModal/Stepper';
import { ChoiceGroup, ChoiceCard } from 'components/BookingModal/ChoiceCards';
import { normalizeHex } from 'helpers/serviceTypeColor';
import { bookingReference } from 'helpers/bookingReference';
import { flatOptionLabel, flatOptionQuantity } from 'helpers/bookingPricing';

var startCountRange = 0
var label= '';
var indexChecked = '';
var selectedAnswer = '';
var url_string = window.location.href;
var url = new URL(url_string);
var is_brand = url.searchParams.get("is_brand");

const items=[ 
  { label: 'Cash', value: 'Cash' }, 
  { label: 'Interac', value: 'Interac' },
  { label: 'Cheque', value: 'Cheque' },
  { label: 'Debit/Credit', value: 'dr/cr' }
];

@inject('bookingStore', 'preferenceStore','serviceTypeStore','pricingParameterStore','frequencyStore','questionGroupStore','store','serviceTypeCategoryStore','viewStore') @observer
class BookingShowPublicPage extends Component {
  @observable pricingParameterArray = [];

  @observable startCountRange = 0;
  @observable extra_service_total = 0;
  @observable pricing_parameter_total = 0;
  @observable pricing_range_total = 0;
  @observable grand_total = 0.0;
  @observable tenant_email = '';
  @observable tenant_logo = '';
  @observable tenant_name = '';
  // Company logo and contacts loaded (or failed): the brand bar can't move the page any more.
  @observable tenantLoaded = false;
  @observable tenant_phone = '';


  componentDidMount() {
    let {
      serviceTypeStore,
      questionGroupStore,
      serviceTypeCategoryStore,
      bookingStore:{
        booking:{
          object
        }
      }
    } = this.props;
    
    if(object && object.attributes){
      this.grand_total = object.attributes.total;
    }
    serviceTypeCategoryStore.loadServiceTypePublicCategories();
    questionGroupStore.loadPublicQuestionGroups();
    serviceTypeStore.loadPublicServiceTypesBooking();
    // Customers opening this link aren't logged in, so read the company's
    // logo and contact details from the public tenant endpoint (the same one
    // the booking form uses). A saved login only fills gaps.
    const currentTenant = Lockr.get('currentTenant');
    if(currentTenant) {
      this.tenant_email = currentTenant.email;
      this.tenant_logo = currentTenant.logo;
      this.tenant_phone = currentTenant.phone;
    }
    const tenantId = this.props.bookingStore.tenant_id;
    if (tenantId) {
      Api.get(`/public/tenants/${tenantId}?x_tenant_id=${tenantId}`)
        .then((response) => {
          const tenantAttributes = (response.data && response.data.data && response.data.data.attributes) || {};
          this.tenant_email = tenantAttributes.email || this.tenant_email;
          this.tenant_logo = tenantAttributes.logo || this.tenant_logo;
          this.tenant_phone = tenantAttributes.phone || this.tenant_phone;
          if (tenantAttributes.name) this.tenant_name = tenantAttributes.name;
        })
        .catch(() => {})
        .then(() => { this.tenantLoaded = true; });
    } else {
      this.tenantLoaded = true;
    }
    window.$crisp.push(['do', 'chat:hide']);
  }

  onAddressSelect(suggestion) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(suggestion) {
      object.attributes.address = suggestion.label;
      suggestion.gmaps && suggestion.gmaps.address_components && suggestion.gmaps.address_components.length > 0 && suggestion.gmaps.address_components.map((address_component) => {
        if(_.includes(address_component.types, "locality")) {
          object.attributes.city = address_component.long_name;
        }

        if(_.includes(address_component.types, "administrative_area_level_1")) {
          object.attributes.state = address_component.long_name;
        }
        
        if(_.includes(address_component.types, "postal_code")) {
          object.attributes.zip = address_component.long_name;
        }
      })
    } else {
      object.attributes.address = '';
      object.attributes.zip = "";
      object.attributes.state = "";
      object.attributes.city = "";
    }
  }

  onAddressClear(value) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(!value) {
      object.attributes.address = '';
    }
  }
  

  onExtraServiceSelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;

    let index = object.attributes.booking_service_type_extras.map(function(item) { return item.name; }).indexOf(selectedOptions.name);
    if(event.target.checked === true) {
      if(index === -1) { 
        object.attributes.booking_service_type_extras.push({service_type_extra_id:selectedOptions.id,name:selectedOptions.name,price:parseFloat(selectedOptions.price_cents/100)});
      } else {
        object.attributes.booking_service_type_extras[index].price = parseFloat(selectedOptions.price_cents/100);
        object.attributes.booking_service_type_extras[index]._destroy = 0;
      }
    } else{ 
      object.attributes.booking_service_type_extras[index].price = 0;
      object.attributes.booking_service_type_extras[index]._destroy = 1;
    }
    this.calculateGrandtotal()
  }

  onFrequencySelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    object.attributes.frequency_id = selectedOptions.id;
  }

  onPricingRangeSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(event.target.value != ''){
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.id;
        object.attributes.booking_pricing_parameters[index].name = event.target.options[event.target.selectedIndex].text;
        object.attributes.booking_pricing_parameters[index].price = parseFloat(event.target.value);
        object.attributes.booking_pricing_parameters[index].total_amount = parseFloat(event.target.selectedIndex) * parseFloat(event.target.value);

      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat(event.target.value),total_amount:parseFloat(event.target.value)});
      
      }
      this.calculateGrandtotal()
    }
  }

  onPricingSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(event.target.value != ''){
      // Quantity is the number in the option label ("Tires x 4" is 4), as the server prices it.
      const quantity = flatOptionQuantity(flatOptionLabel(event));
      const amount = quantity * parseFloat((selectedOptions.price_cents/100));
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].name = event.target.value;
        object.attributes.booking_pricing_parameters[index].price = amount;
        object.attributes.booking_pricing_parameters[index].quantity = quantity;
        object.attributes.booking_pricing_parameters[index].total_amount = amount;
      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:selectedOptions.name,quantity:quantity,total_amount:amount,price:amount});
      }
    } else {
      object.pricing_parameters = [];
    }
    this.calculateGrandtotal()
  }

  // The saved choice for a flat pricing parameter (e.g. "Tires x 3"), so its
  // select shows it. Saved bookings keep choices in booking_pricing_parameters,
  // new ones in pricing_parameters; both store the option text as `name`.
  selectedPricingLabel(pricing) {
    const { object } = this.props.bookingStore.booking;
    const attributes = (object && object.attributes) || {};
    // Option text has its whitespace collapsed by the browser (a name like
    // "Tires x " gives "Tires x  4" in code but "Tires x 4" as the option and
    // as the saved name), so compare and return the collapsed form.
    const tidy = (text) => String(text || '').replace(/\s+/g, ' ').trim();
    const saved = [...(attributes.booking_pricing_parameters || []), ...(attributes.pricing_parameters || [])]
      .map((item) => item && tidy(item.name));
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      const label = tidy(`${pricing.name} ${i}`);
      if (saved.includes(label)) return label;
    }
    return '';
  }

  pricingList = (pricing) => {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    let pricingToReturn = [];
    this.pricingParameterArray = [];
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      let label = `${pricing.name} ${i}`;
      let indexChecked = object.attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(label);
      if(indexChecked > -1){
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }else{
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }
    }
    return pricingToReturn;
  };

  pricingRangeList = (pricing) => {
    let {
      props: {
        pricingParameterStore,
        pricingParameterStore: {
          pricingParameterDetailUpdate: { 
            object
           }
        },
        bookingStore: {
          booking
        },
        serviceTypeStore: {
          serviceTypeDetail,
          princingRangeCombineArray
        }
      }
    } = this;
    
    let pricingRangeToReturn = [];
  
    if(pricing.id){
      let index = pricing.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(pricing.id);
      if(index > -1){
        pricing.pricing_parameter_ranges.map((range) => {
          let label = `${range.label}`;
          let indexChecked = booking.object.attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(label);
          if(indexChecked > -1){
            pricingRangeToReturn.push(<option selected={'selected'} innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }else{
            pricingRangeToReturn.push(<option innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }
        });
      }
    }

    return pricingRangeToReturn;
  };

  handleStartDateChange(date) {
    let { object } = this.props.bookingStore.booking;
    if(date) {
      object.attributes.start_date = moment(date);
    }
  }

  onPaymentSelect = (event,payment,key) => {
    let { object } = this.props.bookingStore.booking;
    object.attributes.payment_method = payment.value;
  }

  onContactWayChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.contact_way = event.target.value;
  }

  onTimePeriodChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.start_project_expected_period = event.target.value;
  }

  onServiceTypeCategoryChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    this.props.viewStore.serviceTypeSearch.where.service_type_category_id = event.target.value;
    this.props.serviceTypeStore.loadServiceTypes() 
    object.attributes.service_type_category_id = event.target.value;
  }

  onServiceTypeChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail,
        princingRangeCombineArray
      }
    } = this.props;
    if(event.target.value !== "") {
      serviceTypeStore.princingRangeCombineArray = [];
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = event.target.value;
      serviceTypeStore.loadPublicServiceTypeDetail({uuid:event.target.value})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  onServiceTypeSelect = (event,service,key) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail,
        princingRangeCombineArray
      }
    } = this.props;
    if(service.attributes.id !== "") {
      this.setState({
        isServiceTypeChecked: service.attributes.id
      });
      serviceTypeStore.princingRangeCombineArray = [];
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = service.attributes.id;
      serviceTypeStore.loadPublicServiceTypeDetail({uuid:service.attributes.id})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
            
          });
          this.calculateGrandtotal()
        })
    }else{
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  calculateGrandtotal() {
    let { 
      bookingStore: {
        booking: {
          object
        }
      },
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;

    object.attributes.total = 0.0;

    // Adding Service type price in grand total
    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      object.attributes.total += serviceTypeDetail.object.attributes.rate;
    }

    // Adding pricing parameters flat/ranges to grand total
    if(object && object.attributes.booking_pricing_parameters && object.attributes.booking_pricing_parameters.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_pricing_parameters, 'price')
    }

    // Adding extra service types to grand total
    if(object && object.attributes.booking_service_type_extras && object.attributes.booking_service_type_extras.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_service_type_extras, 'price')
    }
  }


  validate(bookingStep) {
    let {
      props: {
        bookingStore,
        bookingStore: {
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;
    if(bookingStep === 1){
      if(object.attributes.first_name === "" || object.attributes.first_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.last_name === "" || object.attributes.last_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.email === "" || object.attributes.email === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.phone === "" || object.attributes.phone === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 2){
      if(object.attributes.address === "" || object.attributes.address === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.city === "" || object.attributes.city === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.state === "" || object.attributes.state === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
        return false;
      }
      if(object.attributes.zip === "" || object.attributes.zip === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 3){
      if(object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 4){
      if(object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
        Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if(bookingStep === 5){
      if(object.attributes.payment_method === "" || object.attributes.payment_method === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select payment method!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }

  }

  navigateToNextScreen() {
    let {
      props: {
        bookingStore,
        bookingStore: {
          bookingStep,
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;
    let result = this.validate(bookingStore.bookingStep);
    
    if(bookingStep < 7 && result === true){
      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;

      bookingStore.bookingStep = bookingStep + 1;
      
      switch(bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true;
          break;
        case 2:
          bookingStore.bookingStep2 = true;
          break;
        case 3:
          bookingStore.bookingStep3 = true;
          break;
        case 4:
          bookingStore.bookingStep4 = true;
          break;
        case 5:
          bookingStore.bookingStep5 = true;
          break;
        case 6:
          bookingStore.bookingStep6 = true;
          break;
        default:
          // code block
      }
    }
  }

  navigateToPreviousScreen() {
    let {
      bookingStore,
      bookingStore:{
        bookingStep
      }
    } = this.props;
    if(bookingStep > 1){
      bookingStore.bookingStep = bookingStep - 1;

      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;
      switch(bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true
          break;
        case 2:
          bookingStore.bookingStep2 = true
          break;
        case 3:
          bookingStore.bookingStep3 = true
          break;
        case 4:
          bookingStore.bookingStep4 = true
          break;
        case 5:
          bookingStore.bookingStep5 = true
          break;
        case 6:
          bookingStore.bookingStep6 = true
          break;
        default:
          // code block
      }
    }
  }

  updateBooking() {
    let {
      props: {
        store,
        bookingStore: {
          tenant,
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;

    
    if(object.attributes.first_name === "" || object.attributes.first_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.last_name === "" || object.attributes.last_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.email === "" || object.attributes.email === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.phone === "" || object.attributes.phone === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.address === "" || object.attributes.address === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.city === "" || object.attributes.city === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.state === "" || object.attributes.state === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.zip === "" || object.attributes.zip === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
      return;
    }

    object.attributes.booking_service_type_extras_attributes = object.attributes.booking_service_type_extras;
    object.attributes.booking_pricing_parameters_attributes = object.attributes.booking_pricing_parameters;
    // Validation passed: show progress now, and remember the status so a
    // failed save doesn't leave the booking looking confirmed.
    const previousStatus = object.attributes.status;
    booking.isLoading = true;
    object.attributes.status = 'confirmed';
    object.attributes.booking_questions_attributes = object.attributes.booking_questions;

    this.props.bookingStore
      .updatePublicBooking(object)
      .then(response => {
        // The confirmed notice at the top of the page says the rest; bring it into view.
        Toast.show({ icon: 'tick', message: 'Booking confirmed', intent: Intent.SUCCESS });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch((error) => {
        object.attributes.status = previousStatus;
        booking.isLoading = false;
        const message = (error && error.response && error.response.data && (error.response.data.errors || error.response.data.error)) || 'Changes weren\'t saved. Try again.';
        Toast.show({ icon: 'warning-sign', message: Array.isArray(message) ? message.join(', ') : String(message), intent: Intent.DANGER });
      });
  }

  onChangeFile(event) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    var FileSize = event.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 10) {
      Toast.show({ icon: 'warning-sign', message: 'File size exceeds 10 MB!', intent: Intent.DANGER })
      return
    }
    this.props.bookingStore.uploadPublicBookingAttachment(event.target.files[0], attributes.id)
      .then(this.onSuccessfullUploadAttachment.bind(this))
      .catch(this.onFailUploadAttachment.bind(this))
  }

  onSuccessfullUploadAttachment(response) {
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.booking_attachments.push(response.data.data.attributes);
  }

  onFailUploadAttachment(error) {
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, failed to upload file!', intent: Intent.DANGER })
    }
  }

  removeAttachment(attachment) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    this.props.bookingStore.removePublicAttachment(attachment, attributes.id)
  }

  renderPricingParameters(pricing_parameters, attributes, isConfirmed) {
    if(!(pricing_parameters && pricing_parameters.length > 0)) {
      return null;
    }
    return (
      <div className="bk-pricing">
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing,pricingKey) => {
            if(pricing.pricing_type === 'flat'){
              return (
                <div className="bk-field" key={Math.random()}>
                  <FormGroup label={pricing.name || "Pricing"} labelFor="text-input">
                    <select
                      value={this.selectedPricingLabel(pricing)}
                      className='form-control'
                      placeholder={`Select ${pricing.name}`}
                      onChange={(event) => {this.onPricingSelect(event,pricing)} }
                      disabled={isConfirmed}
                    >
                      <option value="">Select one</option>
                    { this.pricingList(pricing)}
                    </select>
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing) => {
            if(pricing.pricing_type === 'range'){
              return (
                <div className="bk-field" key={Math.random()}>
                  <FormGroup
                    label={pricing.name}
                    labelFor="text-input"
                  >
                    <select
                      className='form-control'
                      placeholder={`Select ${pricing.name}`}
                      onChange={(event) => {this.onPricingRangeSelect(event,pricing)} }
                      disabled={isConfirmed}
                    >
                      <option value="">Select one</option>
                    { this.pricingRangeList(pricing)}
                    </select>
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
      </div>
    );
  }

  render() {
    let {
      store,
      serviceTypeStore: {
        serviceType:{
          objects
        },
        serviceTypeDetail,
      },
      bookingStore:{
        bookingStep,
        bookingStep1,
        bookingStep2,
        bookingStep3,
        bookingStep4,
        bookingStep5,
        bookingStep6,
        showUploadAttachmentLoader,
        booking:{
          object: {
            attributes
          },
          isLoading,
          isError
        }
      },
      questionGroupStore:{
        groups
      },
      serviceTypeCategoryStore:{
        serviceTypeCategories
      }
    } = this.props;

    let service_type_extra = [];
    let pricing_parameters = [];
    let frequency = [];
    let questions = [];

    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      service_type_extra = serviceTypeDetail.object.attributes.service_type_extra
      pricing_parameters = serviceTypeDetail.object.attributes.pricing_parameters
      frequency = serviceTypeDetail.object.attributes.frequency
      questions = serviceTypeDetail.object.attributes.questions;
    }

    // Here the booking's own attributes also carry the tenant's booking form
    // settings (texts, colours, view style).
    const isConfirmed = attributes && attributes.status === 'confirmed' ? true : false;
    // Paid by card: what was paid for (service, options, add-ons, payment
    // method) can only be changed by the company, as the backend enforces.
    const isPaid = Boolean(attributes && attributes.card_paid);
    const pricedLocked = isConfirmed || isPaid;
    const isWidget = Boolean(attributes && attributes.booking_view_style === 'widget');
    const isBranded = is_brand === 'true';
    const showPrices = Boolean(attributes && attributes.enable_booking_price_display);
    const brandHex = normalizeHex(attributes && attributes.booking_form_color) || '#1800FF';
    const confirmLabel = attributes && attributes.cta_title ? attributes.cta_title : 'Confirm booking';
    const paymentEnabled = Boolean(attributes && attributes.booking_payment_method === true);
    const stepLabels = ['Your details', 'Address', 'Service', 'Timing', paymentEnabled ? 'Payment' : 'Files', 'Note'];

    const serviceDetailAttributes = serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes;
    const selectedServiceType = attributes && attributes.service_type_id && _.find(objects, (service) => service.attributes && String(service.attributes.id) === String(attributes.service_type_id));
    const serviceColor = (selectedServiceType && selectedServiceType.attributes.color) || (serviceDetailAttributes && serviceDetailAttributes.color);
    const customerName = attributes ? [attributes.first_name, attributes.last_name].filter((part) => part && String(part).trim() !== '').join(' ') : '';

    const startDate = attributes && attributes.start_date ? moment(attributes.start_date) : null;
    const headerMeta = [
      attributes && attributes.id ? `Reference ${bookingReference(attributes.id)}` : null,
      startDate && startDate.isValid() ? startDate.format('ddd, MMM D, YYYY [at] h:mm A') : null,
      isPaid ? `Paid ${currencyFormattedAmount((attributes.amount_paid_cents || 0) / 100)} by card` : null,
    ].filter(Boolean).join(' · ');

    const ticketGroups = [];
    if(attributes && attributes.booking_pricing_parameters && attributes.booking_pricing_parameters.length > 0) {
      ticketGroups.push({
        key: 'pricing',
        title: attributes.pricing_title ? attributes.pricing_title : 'Pricing',
        lines: attributes.booking_pricing_parameters.map((parameter, index) => ({
          key: `pricing-${index}`,
          label: parameter.name,
          amount: showPrices && attributes.enable_booking_pricing_parameter ? currencyFormattedAmount((parameter.price)) : null
        }))
      });
    }
    if(service_type_extra && service_type_extra.length > 0 && attributes && attributes.booking_service_type_extras) {
      ticketGroups.push({
        key: 'extras',
        title: 'Add-ons',
        lines: attributes.booking_service_type_extras
          .filter((ext_service) => ext_service._destroy !== 1)
          .map((ext_service, index) => ({
            key: `extra-${index}`,
            label: ext_service.name,
            amount: showPrices ? currencyFormattedAmount(ext_service.price) : null
          }))
      });
    }

    const confirmButton = (
      <Button
        className={isConfirmed ? "bk-public__confirm disable-confirm-btn" : "bk-public__confirm"}
        intent={Intent.PRIMARY}
        icon={isConfirmed ? 'tick' : undefined}
        onClick={this.updateBooking.bind(this)}
        loading={isLoading}
        disabled={isConfirmed}
      >
        {isConfirmed ? 'Confirmed' : confirmLabel}
      </Button>
    );

    const contactLinks = [];
    if(this.tenant_phone) {
      contactLinks.push(<a key="phone" href={`tel:${this.tenant_phone}`}>{this.tenant_phone}</a>);
    }
    if(this.tenant_email) {
      contactLinks.push(<a key="email" href={`mailto:${this.tenant_email}`}>{this.tenant_email}</a>);
    }

    // The link points at a booking that no longer exists (or never did).
    if (isError && !isLoading) {
      return (
        <div className="bk-page bk-public" style={bookingBrandStyle()}>
          <Helmet>
            <title>Booking not found | FieldNexus</title>
          </Helmet>
          <div className="bk-public__missing">
            {this.tenant_logo && <img className="bk-public__logo" src={this.tenant_logo} alt={this.tenant_name ? `${this.tenant_name} logo` : 'Company logo'} />}
            <h1 className="bk-public__missing-title">We couldn't find this booking</h1>
            <p className="bk-public__missing-text">
              The link may be out of date, or the booking was cancelled.
              {contactLinks.length > 0 ? ' Get in touch and we\'ll sort it out:' : ' Contact the company that sent it to you.'}
            </p>
            {contactLinks.length > 0 && <p className="bk-public__missing-contacts">{contactLinks}</p>}
          </div>
        </div>
      );
    }

    // Hold a skeleton until everything that shapes the page has loaded, so it
    // doesn't jump as pieces arrive: the booking, the company's logo and
    // contacts (brand bar), the categories, and the booked service's details.
    // Each of these clears its loading flag on failure too.
    const detail = serviceTypeDetail || {};
    const serviceReady = !(attributes && attributes.service_type_id)
      || detail.isError
      || (!detail.isLoading && detail.object && String(detail.object.id) === String(attributes.service_type_id));
    const pageReady = !isLoading && attributes && attributes.id && this.tenantLoaded
      && !(serviceTypeCategories && serviceTypeCategories.isLoading) && serviceReady;
    if (!pageReady) {
      return (
        <div className="bk-page bk-public" style={bookingBrandStyle()}>
          <Helmet>
            <title>Your booking | FieldNexus</title>
          </Helmet>
          <BookingPageSkeleton bar={true} branded={isBranded} />
        </div>
      );
    }

    return (
      <div
        className={`bk-page bk-public${isWidget ? ' bk-public--widget' : ''}`}
        style={bookingBrandStyle(attributes && attributes.booking_form_color, attributes && attributes.booking_form_bgcolor)}
      >
        <Helmet>
          <title>{`Your booking | ${(attributes && attributes.booking_page_title) || 'FieldNexus'}`}</title>
        </Helmet>
        {/* The date picker opens in a portal outside this page, so it gets the brand colour here. */}
        <style dangerouslySetInnerHTML={{__html: `
          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background-color: ${brandHex} !important;
          }
        `}} />
        {
          <React.Fragment>
            { isBranded ?
              <div className="bk-public__bar">
                <div className="bk-public__bar-inner">
                  <div className="bk-public__brand">
                    {this.tenant_logo && <img className="bk-public__logo" src={this.tenant_logo} alt={this.tenant_name ? `${this.tenant_name} logo` : 'Company logo'} />}
                    {this.tenant_name && <span className="bk-public__name">{this.tenant_name}</span>}
                  </div>
                  <div className="bk-public__contacts">
                    { this.tenant_email &&
                      <a className="bk-public__contact" href={`mailto:${this.tenant_email}`}>
                        <Icon icon="envelope" iconSize={16} />
                        {this.tenant_email}
                      </a>
                    }
                    { this.tenant_phone &&
                      <a className="bk-public__contact" href={`tel:${this.tenant_phone}`}>
                        <Icon icon="phone" iconSize={16} />
                        {this.tenant_phone}
                      </a>
                    }
                  </div>
                </div>
              </div>
              :
              (this.tenant_logo || this.tenant_name) &&
              <div className="bk-public__bar bk-public__bar--plain">
                <div className="bk-public__bar-inner">
                  <div className="bk-public__brand">
                    {this.tenant_logo && <img className="bk-public__logo" src={this.tenant_logo} alt={this.tenant_name ? `${this.tenant_name} logo` : 'Company logo'} />}
                    {this.tenant_name && <span className="bk-public__name">{this.tenant_name}</span>}
                  </div>
                </div>
              </div>
            }

            <BookingPageHeader
              title="Your booking"
              status={attributes && attributes.status}
              meta={headerMeta}
            />

            <div className={`bk-layout${bookingStep6 === true ? '' : ' bk-layout--single'}`}>
              { isConfirmed &&
                  <div className="bk-public__notice" role="status">
                    <span className="bk-public__notice-icon"><Icon icon="tick" iconSize={16} /></span>
                    <div>
                      <p className="bk-public__notice-title">{(attributes && attributes.booking_confirmation_message_title) || 'Your booking is confirmed'}</p>
                      {attributes && attributes.booking_confirmation_message && (
                        <p className="bk-public__notice-text">{attributes.booking_confirmation_message}</p>
                      )}
                      <p className="bk-public__notice-text">
                        These details can no longer be changed here. To change anything, please call or email us
                        {contactLinks.length > 0 ? ': ' : '.'}
                        {contactLinks.length > 0 && contactLinks.reduce((all, link, index) => (index === 0 ? [link] : [...all, ' or ', link]), [])}
                        {contactLinks.length > 0 ? '.' : ''}
                      </p>
                    </div>
                  </div>
              }
              <div className="bk-form">
                { isWidget &&
                  <BookingStepper steps={stepLabels} current={bookingStep || 1} />
                }
                {
                  bookingStep1 === true ?
                  <BookingSection number={1} title="Your details" helper="How we can reach you about this booking.">
                    <div className="bk-grid bk-grid--2">
                      <div className="bk-field">
                        <FormGroup
                          label={"First name"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='text'
                            className='form-control'
                            placeholder='First name'
                            autoComplete="given-name"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            defaultValue={attributes && attributes.first_name}
                            onChange={(event) => {attributes.first_name = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Last name"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Last name'
                            autoComplete="family-name"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            defaultValue={attributes && attributes.last_name}
                            onChange={(event) => {attributes.last_name = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Email"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='email'
                            className='form-control'
                            placeholder='you@example.com'
                            autoComplete="email"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            defaultValue={attributes && attributes.email}
                            onChange={(event) => {attributes.email = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Phone"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='tel'
                            className='form-control'
                            placeholder='Ex. 9876543210'
                            autoComplete="tel"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            defaultValue={attributes && attributes.phone}
                            onChange={(event) => {attributes.phone = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </BookingSection>
                  :''
                }
                {
                  bookingStep2 === true ?
                  <BookingSection number={2} title="Service address" helper="Where should we do the work?">
                    <div className="bk-grid bk-grid--address">
                      <div className="bk-field bk-field--address">
                        <FormGroup
                          label={"Address"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <GeoComplete
                            className='form-control geo-control'
                            placeholder="Start typing your address"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            initialValue={attributes && attributes.address}
                            onSuggestSelect={this.onAddressSelect.bind(this)}
                            onChange={this.onAddressClear.bind(this)}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Address line 2"}
                          labelFor="text-input"
                        >
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Apartment, suite, unit'
                            autoComplete="address-line2"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            defaultValue={attributes && attributes.suite}
                            onChange={(event) => {attributes.suite = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <div className="bk-grid bk-grid--3">
                      <div className="bk-field">
                        <FormGroup
                          label={"City"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='text'
                            className='form-control'
                            placeholder='City'
                            autoComplete="address-level2"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            value={(attributes && attributes.city) || ''}
                            onChange={(event) => {attributes.city = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"State or province"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='text'
                            className='form-control'
                            placeholder='State or province'
                            autoComplete="address-level1"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            value={(attributes && attributes.state) || ''}
                            onChange={(event) => {attributes.state = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Zip or postal code"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Ex. 0377'
                            autoComplete="postal-code"
                            disabled={attributes && attributes.status === 'confirmed' ? true : false}
                            value={(attributes && attributes.zip) || ''}
                            onChange={(event) => {attributes.zip = event.target.value;}}
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </BookingSection>
                  :''
                }
                {
                  bookingStep3 === true ?
                  <BookingSection
                    number={3}
                    title={attributes && attributes.heading_text_for_service_type ? attributes.heading_text_for_service_type : 'Service'}
                    helper={isConfirmed ? 'The service you booked.' : 'Pick a category, then the service you need.'}
                  >
                    {
                      serviceTypeCategories.objects &&
                      <div className="bk-grid bk-grid--2">
                        <div className="bk-field">
                          <FormGroup label={'Category'} labelFor="text-input" labelInfo={"*"}>
                            <div className="bk-select">
                              <select
                                className='form-control'
                                onChange={this.onServiceTypeCategoryChange.bind(this)}
                                disabled={pricedLocked}
                                value={attributes && attributes.service_type_category_id || ''}
                              >
                                <option value="">Select a category</option>
                                { serviceTypeCategories.objects.map((category) => {
                                    return(
                                      <option value={category.attributes.id} key={category.attributes.id}>{category.attributes.name}</option>
                                    )
                                  })
                                }
                              </select>
                              { serviceTypeCategories.objects.length === 0 ?
                                  <Spinner className="bk-select__spinner" size={Spinner.SIZE_SMALL} />
                                  :
                                  ""
                              }
                            </div>
                          </FormGroup>
                        </div>
                      </div>
                    }
                    {
                      attributes && attributes.display_service_type === 'Icon' && attributes.service_type_category_id != '' ?
                        <div className="bk-subsection">
                          <span className="bk-label">Service <span className="bp3-text-muted">*</span></span>
                          <ChoiceGroup label="Service" className="bk-choices">
                            { objects && objects.map((service,key) => {
                                if(service.attributes.display_on_booking_form) {
                                  const checked = service.id === attributes.service_type_id ? true: false;
                                  const disabled = pricedLocked;
                                  const accent = normalizeHex(service.attributes.color);
                                  return (
                                    <ChoiceCard
                                      key={service.id || key}
                                      className={`bk-choice--service${disabled ? ' is-disabled' : ''}`}
                                      checked={checked}
                                      style={accent ? { '--bk-service': accent } : undefined}
                                      onSelect={(event) => { if(!checked && !disabled) { this.onServiceTypeSelect(event,service,key) } }}
                                    >
                                      <span className="bk-choice__check" aria-hidden="true"><Icon icon="tick" iconSize={10} /></span>
                                      {service.attributes.logo ?
                                        <span className="bk-choice__logo"><img src={service.attributes.logo} alt="" /></span>
                                        :
                                        <span className="bk-choice__dot" aria-hidden="true" />
                                      }
                                      <span className="bk-choice__name">{service.attributes.name}</span>
                                    </ChoiceCard>
                                  )
                                }
                              })
                            }
                          </ChoiceGroup>
                          {this.renderPricingParameters(pricing_parameters, attributes, pricedLocked)}
                        </div>
                        :
                        <div className="bk-subsection">
                          {attributes.service_type_category_id != '' ?
                            <div>
                              <div className="bk-grid bk-grid--2">
                                <div className="bk-field">
                                  <FormGroup label={attributes && attributes.another_heading_text_for_service ? attributes.another_heading_text_for_service : 'Service'} labelFor="text-input" labelInfo={"*"}>
                                    <ServiceTypeSelectWrap color={serviceColor}>
                                      <select
                                        disabled={pricedLocked}
                                        className='form-control'
                                        value={attributes && attributes.service_type_id || ''}
                                        onChange={this.onServiceTypeChange.bind(this)}
                                      >
                                        <option value="">Select a service</option>
                                        { objects && objects.map((service) => {
                                            if(service.attributes.display_on_booking_form) {
                                              return(
                                                <option
                                                  value={service.attributes.id}
                                                  key={service.attributes.id}
                                                >
                                                    {service.attributes.name}
                                                </option>
                                              )
                                            }
                                          })
                                        }
                                      </select>
                                    </ServiceTypeSelectWrap>
                                  </FormGroup>
                                </div>
                              </div>
                              {this.renderPricingParameters(pricing_parameters, attributes, pricedLocked)}
                            </div>
                          :''}
                        </div>
                    }

                    {service_type_extra && service_type_extra.length > 0 && <div className="bk-subsection">
                      <h3 className="bk-subsection__title">Add-ons</h3>
                      <div className="bk-cards">
                        {
                          service_type_extra.map((extra,key) => {
                            indexChecked = attributes.booking_service_type_extras.map(function(item) { return item._destroy !== 1 ? item.service_type_extra_id : ""; }).indexOf(extra.id);
                            if(indexChecked > -1){
                              label = extra.id;
                            }
                            return (
                              <div className={`bk-card ${label === extra.id ? 'bk-card--active' :''}`} key={Math.random()}>
                                <span className="bk-card__icon">
                                  {extra.icon_file && extra.icon_file.thumb && extra.icon_file.thumb.url && <img src={extra.icon_file.thumb.url} alt="" />}
                                </span>
                                <span className="bk-card__label">{extra.name}</span>
                                <Checkbox label="" type="checkbox"
                                  className="bk-card__control"
                                  aria-label={extra.name}
                                  defaultChecked={label === extra.id ? true : false}
                                  disabled={pricedLocked}
                                  onChange={(event) => {this.onExtraServiceSelect(event,extra,key)} }
                                />
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>}

                    {hasGroupedQuestions(groups, questions) && <div className="bk-subsection">
                      <h3 className="bk-subsection__title">A few more details</h3>
                      <div className="bk-questions">
                      {
                        groups.objects.map(function(group) {
                          var isInGroup = questions.map(function(item) { return item.question_group_id; }).indexOf(group.id);
                          if(isInGroup > -1) {
                            return(
                              <div className="bk-question-group" key={Math.random()}>
                                <h3 className="bk-subsection__title">{group.attributes.question}</h3>
                                {questions && questions.length > 0 && questions.map((question, index) => {
                                    indexChecked = attributes.booking_questions.map(function(item) { return item.question_id; }).indexOf(question.id);
                                    if(indexChecked > -1){
                                      label = question.id;
                                      selectedAnswer = attributes.booking_questions[indexChecked].answer;
                                    }
                                    if(group.attributes.id === question.question_group_id){
                                    return(
                                      <div className="bk-question" key={Math.random()}>
                                        <span className="bk-label">{question.field_label}</span>
                                        <div className="bk-question__answer">
                                          {question.field_type === "Checkbox" && <div>
                                            <RadioGroup inline={true} className="bk-radio-group" name="question_radio">
                                              {question.field_value && question.field_value.split(/\r?\n/).map((answer) => {
                                                return(
                                                  <QuestionRadio
                                                    inline= {true}
                                                    question={question}
                                                    bookingStatus={attributes && attributes.status}
                                                    answer={answer}
                                                    checkedValue={label}
                                                    selectedAnswer={selectedAnswer}
                                                  />
                                                )
                                              })}
                                            </RadioGroup>
                                            </div>}
                                            {question.field_type === "Dropdown"  && <div className="bk-question__control">
                                              <QuestionSelect
                                                inline= {true}
                                                bookingStatus={attributes && attributes.status}
                                                question={question}
                                                checkedValue={label}
                                                selectedAnswer={selectedAnswer}
                                              />
                                            </div>}
                                            {question.field_type === "Textbox"  && <div className="bk-question__control">
                                              <QuestionTextbox
                                                inline= {true}
                                                bookingStatus={attributes && attributes.status}
                                                question={question}
                                                selectedAnswer={selectedAnswer}
                                              />
                                            </div>}
                                        </div>
                                      </div>
                                    )}})
                                  }
                              </div>
                            )
                          }
                        })
                      }
                      </div>
                    </div>
                    }
                  </BookingSection>
                  :''
                }
                {
                  bookingStep4 === true ?
                  <BookingSection number={4} title="Timing" helper="When you would like to get started.">
                    <div className="bk-grid bk-grid--2">
                      {attributes && attributes.booking_start_project_expected_period && (
                      <div className="bk-field">
                        <FormGroup label={"How soon would you like to start?"} labelFor="text-input">
                          <select
                            className='form-control'
                            placeholder={`Select `}
                            onChange={this.onTimePeriodChange.bind(this)}
                            disabled={isConfirmed}
                            defaultValue={attributes && attributes.start_project_expected_period && attributes.start_project_expected_period}
                          >
                            <option value="">Select one</option>
                            { attributes && attributes.booking_start_project_expected_period && attributes.booking_start_project_expected_period.split(/\r?\n/).map((period) => {
                              var selected = '';
                              if(attributes.start_project_expected_period === period.split(":")[1]){
                                selected = 'selected'
                              }
                              return(
                                <option value={period.split(":")[1]}>{period.split(":")[0]}</option>
                              )})}
                          </select>
                        </FormGroup>
                      </div>
                      )}
                      {attributes && attributes.booking_contact_way && (
                      <div className="bk-field">
                        <FormGroup label={"How should we contact you?"} labelFor="text-input">
                          <select
                            className='form-control'
                            placeholder={`Select `}
                            onChange={this.onContactWayChange.bind(this)}
                            disabled={isConfirmed}
                            defaultValue={attributes && attributes.contact_way && attributes.contact_way}
                          >
                            <option value="">Select one</option>
                            {attributes && attributes.booking_contact_way && attributes.booking_contact_way.split(/\r?\n/).map((way) => {
                              var selected = '';
                              if(attributes.contact_way === way.split(":")[1]){
                                selected = 'selected'
                              }
                              return(
                                <option value={way.split(":")[1]}>{way.split(":")[0]}</option>
                              )})}
                          </select>
                        </FormGroup>
                      </div>
                      )}
                    </div>
                    {attributes && attributes.enable_visit_us === true &&
                      <div className="bk-subsection">
                        <div className="bk-grid bk-grid--2">
                          <div className="bk-field booking_form_date">
                            <FormGroup
                              label={"When would you like us to visit?"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <DateTimeInput
                                placeholder={'Pick a date'}
                                bookingStatus={attributes && attributes.status}
                                defaultValue={attributes && attributes.start_date && moment(attributes.start_date)}
                                onChange={this.handleStartDateChange.bind(this)}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                    }
                    {attributes && attributes.enable_often_visit_us === true &&
                      <div>
                        {frequency && frequency.length > 0 && <div className="bk-subsection">
                          <span className="bk-label">How often should we visit?</span>
                          <div className="bk-chips">
                            {
                              frequency.map((freqncy,frequencyKey) => {
                                if(attributes && attributes.frequency_id){
                                  label = attributes.frequency_id;
                                }
                                return (
                                  attributes && attributes.status === 'confirmed' ?
                                  <button
                                    type="button"
                                    key={Math.random()}
                                    disabled={true}
                                    aria-pressed={label == freqncy.id ? 'true' : 'false'}
                                    className={`bk-chip ${label == freqncy.id ? 'bk-chip--active' : ''}`}
                                  >
                                    {freqncy.title}
                                  </button>
                                  :
                                  <button
                                    type="button"
                                    key={Math.random()}
                                    aria-pressed={label == freqncy.id ? 'true' : 'false'}
                                    onClick={(event) => {this.onFrequencySelect(event,freqncy,frequencyKey)} }
                                    className={`bk-chip ${label == freqncy.id ? 'bk-chip--active' : ''}`}
                                  >
                                    {freqncy.title}
                                  </button>
                                )
                              })
                            }
                          </div>
                        </div>}
                      </div>
                    }
                  </BookingSection>
                  :''
                }
                {
                  bookingStep5 === true ?
                  <BookingSection
                    number={5}
                    title={paymentEnabled ? 'Payment and files' : 'Photos and files'}
                    helper={paymentEnabled ? 'How you would like to pay, plus any photos or documents that help us.' : 'Photos or documents that help us understand the job. Up to 10 MB each.'}
                  >
                    {attributes && attributes.booking_payment_method === true &&
                      <div className="bk-field">
                        <span className="bk-label">Payment method</span>
                        <div className="bk-chips">
                          {
                            // Cards are taken on the booking form only; here Debit/Credit
                            // just shows when it's already this booking's method.
                            items.filter((payment) => payment.value !== 'dr/cr' || (attributes && attributes.payment_method === 'dr/cr')).map((payment,paymentKey) => {
                              if(attributes && attributes.payment_method){
                                label = attributes.payment_method;
                              }
                              return (
                                pricedLocked ?
                                <button
                                  type="button"
                                  key={Math.random()}
                                  disabled={true}
                                  aria-pressed={label === payment.value ? 'true' : 'false'}
                                  className={`bk-chip ${label === payment.value ? 'bk-chip--active' : ''}`}
                                >
                                  {payment.label}
                                </button>
                                :
                                <button
                                  type="button"
                                  key={Math.random()}
                                  aria-pressed={label === payment.value ? 'true' : 'false'}
                                  onClick={(event) => {this.onPaymentSelect(event,payment,paymentKey)} }
                                  className={`bk-chip ${label === payment.value ? 'bk-chip--active' : ''}`}
                                >
                                  {payment.label}
                                </button>
                              )
                            })
                          }
                        </div>
                      </div>
                    }
                    <div className={paymentEnabled ? 'bk-subsection' : ''}>
                      <BookingAttachments
                        title="Add photos or files (optional)"
                        attachments={attributes && attributes.booking_attachments}
                        uploading={showUploadAttachmentLoader}
                        disabled={attributes && attributes.status === 'confirmed' ? true : false}
                        onChange={this.onChangeFile.bind(this)}
                        onRemove={(attachment) => this.removeAttachment(attachment)}
                      />
                    </div>
                  </BookingSection>
                  :''
                }
                {
                  bookingStep6 === true ?
                  <BookingSection number={6} title="Anything else?" helper="A note for our team if there is something we should know. Optional.">
                    <div className="bk-field">
                      <textarea
                        type='text'
                        className='form-control'
                        placeholder='Type here...'
                        aria-label="Note"
                        disabled={attributes && attributes.status === 'confirmed' ? true : false}
                        value={attributes && attributes.note || ''}
                        onChange={(event) => {attributes.note = event.target.value;}}
                      />
                    </div>
                  </BookingSection>
                  :''
                }
                { attributes && attributes.booking_view_style === 'widget' &&
                  <div className="bk-public__nav">
                    <Button
                      className="bk-public__nav-prev"
                      icon="arrow-left"
                      disabled={bookingStep && bookingStep === 1 ? true : false}
                      onClick={this.navigateToPreviousScreen.bind(this)}
                      style={{display:`${bookingStep && bookingStep === 1 ? 'none' :'block'}`}}
                    >
                      Back
                    </Button>
                    <Button
                      className="bk-public__nav-next"
                      intent={Intent.PRIMARY}
                      rightIcon="arrow-right"
                      onClick={this.navigateToNextScreen.bind(this)}
                      disabled={bookingStep && bookingStep === 6 ? true : false}
                      style={{display:`${bookingStep && bookingStep === 6 ? 'none' :'block'}`}}
                    >
                      Continue
                    </Button>
                  </div>
                }
              </div>
              {
                bookingStep6 === true ?
                <div className="bk-aside">
                  <BookingTicket
                    date={attributes && attributes.start_date}
                    customerName={customerName}
                    contact={attributes && [attributes.email, attributes.phone].filter((part) => part).join(', ')}
                    address={attributes && attributes.address ? joinAddress(attributes.address, attributes.suite, attributes.city, attributes.state, attributes.zip) : null}
                    serviceName={serviceDetailAttributes ? serviceDetailAttributes.name : null}
                    serviceDetail={serviceDetailAttributes && showPrices ? `1 × ${currencyFormattedAmount(parseFloat(serviceDetailAttributes.rate))}` : null}
                    serviceAmount={serviceDetailAttributes && showPrices ? currencyFormattedAmount(serviceDetailAttributes.rate) : null}
                    serviceColor={serviceColor}
                    groups={ticketGroups}
                    showTotal={showPrices}
                    totalLabel="Estimated total"
                    total={currencyFormattedAmount(attributes && attributes.total)}
                  >
                    {confirmButton}
                    {
                      isConfirmed ?
                      <p className="bk-ticket__note">Already confirmed. To make changes, please call or email us.</p>
                      :
                      ''
                    }
                  </BookingTicket>
                </div>
                :""
              }
            </div>

            { bookingStep6 === true && !isConfirmed &&
              <div className="bk-public__mobile-bar">
                {showPrices &&
                  <span className="bk-public__mobile-total">
                    Estimated total
                    <strong>{currencyFormattedAmount(attributes && attributes.total)}</strong>
                  </span>
                }
                {confirmButton}
              </div>
            }
          </React.Fragment>
        }
      </div>
    );
  }

};
export default BookingShowPublicPage;
